<template>
  <div>
    <please-wait-modal/>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">{{ this.$route.query.id != null ? 'Edit' : 'Add' }} Discount</h1>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group col-12">
          <div class="row px-3">
            <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Publish</label>
            <div class="form-check">
              <input class="form-check-input" type="radio" v-model="publish" id="radio_publish_yes" value="1">
              <label class="form-check-label" for="radio_publish_yes">
                Yes
              </label>
            </div>
            <div class="form-check pl-5">
              <input class="form-check-input" type="radio" v-model="publish" id="radio_publish_no" value="0">
              <label class="form-check-label" for="radio_publish_no">
                No
              </label>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-name" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Discount</label>
            <div class="input-group col-lg-8 p-0">
              <input class="form-control" id="form-name" v-model="discount"/>
              <div class="input-group-append">
                <span class="input-group-text" id="basic-addon1">%</span>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Type</label>
            <select class="form-control col-lg-8" v-model="type">
              <!-- <option value="call">Kasual</option>
              <option value="interested">Formal</option> -->
              <option value="point">Top up point</option>
              <!-- <option value="register">Registrasi</option>
              <option value="verifikasi">Verifikasi</option> -->
              <!-- <option value="all">Semua</option> -->
            </select>
          </div>
        </div>
        <div class="form-group" v-show="type === 'point'">
          <div class="row px-3">
            <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Nominal Point</label>
            <select class="form-control col-lg-8" v-model="nominal_point">
              <option v-for="(data, index) in arr_nominal_point" :value="data.id">Rp. {{ data.nominal.toLocaleString('id-ID') }}</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Start At</label>
            <v-date-picker v-model="start_at" :masks="masks" :max-date="end_at != '' ? new Date(end_at) : null" :min-date="new Date()"/>
          </div>
        </div>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-title" class="col-lg-4 pl-0 m-0 d-flex align-items-center">End At</label>
            <v-date-picker v-model="end_at" :masks="masks" :min-date="start_at != '' ? new Date(start_at) : new Date()"/>
          </div>
        </div>
        <div class="form-group text-right">
          <a type="button" class="btn btn-danger" href="/discount">Cancel</a>
          <button type="button" class="btn btn-primary" @click="save">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import please_wait_modal from '@/layout/please_wait_modal'
import publish_web from '@/layout/publish_web'
import modal_edit from '@/pages/master/helper_sub_category/modal_edit_sub_sub_category'

export default {
  components:{
    'please-wait-modal': please_wait_modal,
    'publish-web': publish_web,
    'modal-edit': modal_edit,
  },
  data(){
    return{
      discount: 0,
      point_amount: 0,
      publish: 0,
      type: 'point',
      start_at: '',
      end_at: '',
      nominal_point: '',
      arr_nominal_point: [],
      masks: {
        input: 'DD/MM/YYYY', // Uses 'iso' if missing
      },
    }
  },
  watch:{
    discount(val){
      var disc = val != '' ? parseFloat(val.replace(/\./g,'')) : 0
      if(disc > 100)
        disc = 100
      this.discount = disc.toLocaleString('id-ID')
    },
    point_amount(val){
      this.point_amount = val != '' ? parseFloat(val.replace(/\./g,'')).toLocaleString('id-ID') : '0'
    },
  },
  async created(){
    await this.get_nominal_point_data()
    if(this.$route.query.id != null){
      await this.get_data()
    }
  },
  methods:{
    async save(){
      try{
        if(this.discount === '0' || this.discount === 0)
          this.$toasted.show('Discount is empty')
        else if(this.start_at === '')
          this.$toasted.show('Start At is empty')
        else if(this.end_at === '')
          this.$toasted.show('End At is empty')
        else if(this.type === 'point' && this.nominal_point === '')
          this.$toasted.show('Nominal Point is empty')
        else{
          $('#please_wait_modal').modal('show')
          var data = {}
          if(this.$route.query.id != null)
            data.id = this.$route.query.id

          data.point_amount = !Number.isInteger(this.point_amount) ? parseFloat(this.point_amount.replace(/\./g,'')) : this.point_amount
          data.start_date = moment(this.start_at).format('YYYY-MM-DD')
          data.end_date = moment(this.end_at).format('YYYY-MM-DD')
          data.discount = !Number.isInteger(this.discount) ? parseFloat(this.discount.replace(/\./g,'')) : this.discount
          data.type = this.type
          data.is_publish = this.publish
          data.nominal_point = {
            id: this.nominal_point
          }

          if(this.$route.query.id == null)
            var response = await axios.post(base_url+'/discount',data)
          else
            var response = await axios.put(base_url+'/discount',data)

          $('#please_wait_modal').modal('hide')
          var response_data = response.data
          if(response_data.status == "success"){
            location.href = '/discount'
          }
          else
            this.$toasted.show(response_data.message)
        }
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e)
      }
    },
    async get_data(){
      try{
        var response = await axios.get(base_url+'/discount?id='+this.$route.query.id)

        var response_data = response.data
        if(response_data.status == "success"){
          this.nominal_point = response_data.data.nominal_point_id
          this.start_at = new Date(response_data.data.start_date)
          this.end_at = new Date(response_data.data.end_date)
          this.discount = response_data.data.discount.toLocaleString('id-ID')
          this.type = response_data.data.type
        }
      } catch(e) {
        this.$toasted.show(e)
      }
    },
    async get_nominal_point_data(){
      try{
        var response = await axios.get(base_url+'/nominal-point/all')

        var response_data = response.data
        if(response_data.status == "success"){
          this.arr_nominal_point = response_data.data
        }
      } catch(e) {
        this.$toasted.show(e)
      }
    },
  }
}
</script>
